// Filter pill rows: the fade + "Meer →" control appear per row while that row overflows, on every breakpoint
(() => {
  const rows = document.querySelectorAll('.cm-subcats [data-cm-row]');
  if (!rows.length) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  rows.forEach((row) => {
    const track = row.querySelector('[data-cm-track]');
    const prev = row.querySelector('[data-cm-prev]');
    const next = row.querySelector('[data-cm-next]');
    if (!track) return;
    const update = () => {
      const max = track.scrollWidth - track.clientWidth - 1;
      const left = track.scrollLeft > 1;
      const right = track.scrollLeft < max;
      row.dataset.overflow = left && right ? 'both' : left ? 'left' : right ? 'right' : '';
    };
    const step = (dir) => track.scrollBy({ left: dir * track.clientWidth * 0.6, behavior: reduced.matches ? 'auto' : 'smooth' });
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    // the stylesheet can land after this deferred script ran; re-measure once fonts and CSS are final
    window.addEventListener('load', update);
    update();
  });
})();
